export const VIEWER_BORDER_COLOR_COUNT = 10;

/**
 * Assigns position-based color indices to a sorted list of presences, guaranteeing no
 * duplicates as long as the number of active users is ≤ VIEWER_BORDER_COLOR_COUNT.
 * Returns a Map of userId → colorIndex.
 */
export function assignViewerColorIndices(
  presences: Array<{ userId?: string; user?: { id?: string } }>
): Map<string, number> {
  const map = new Map<string, number>();
  presences.forEach((p, index) => {
    const id = String(p.userId ?? p.user?.id ?? '');
    if (id) map.set(id, index % VIEWER_BORDER_COLOR_COUNT);
  });
  return map;
}
